<template class="item-group-page">
  <section class="r-item-group-page">
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="classObj"
      item-key="uid"
      fixed-header
      :footer-props="footer"
      :items-per-page="50"
      :height="winsize.height - 145 - 48"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Item Group"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Item Group
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-item-group-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </section>
</template>

<script>

import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import clsx from "clsx";

import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import RItemGroupDialog from "@/modules/redactor/views/item-group/r-item-group-dialog.vue";
import {ItemGroupModel} from "@/modules/redactor/models/item/core/ItemGroupModel";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  name: "r-item-group-page",
  components: {RDialogPreviewCollection, AcDataTable, RItemGroupDialog },
  data: () => ({
    search: "",
    headers: [
      {text: "Key", value: "key"},
      {text: "Code", value: "code"},
      {text: "Priority", value: "priority"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(ItemGroupModel)
    },
    selected: [],
    bulkMode: false,
    footer: {
      "items-per-page-options": [10, 50, 100, -1]
    }
  }),

  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },

  methods: {
    classObj(item) {
      const highlightClass =
        item.global ? "cyan lighten-4" :
        item.export ? "green lighten-3" :
        item.changed ? "blue lighten-3" :
        !item.enabled ? "blue-grey lighten-3" :
        "";

      return clsx("item-group-page__item", highlightClass);
    },

    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },

    row_copy(item) {
      this.$refs["dialog"].show(ViewRules.COPY, item.copy()).then(
          result => {
            if (this.item_duplicate(result)) {
              this.$alert("Duplicate item group!");
            } else {
              RedactorUtils.pushItemGroup(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }, () => {
          });
    },

    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            if (this.item_duplicate(result)) {
              this.$alert("Duplicate item group!");
            } else {
              RedactorUtils.pushItemGroup(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }, () => {
          });
    },

    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushItemGroup(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },

    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item group?").then(() => {
        RedactorUtils.removeItemGroup(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkItemGroups(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushItemGroup(result);
    },

    item_duplicate(item) {
      return this.items.find(v => {
        if (v.item && item.item && v.item.equal(item.item)) {
          return v.uid !== item.uid;
        }

        return false;
      });
    },

    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, ItemGroupModel, "item-group")
          .then(() => this.$alert("Changes was published"));
    },
  },

  created() {
    this.items = RedactorUtils.getItemGroups();
  }
}

</script>

<style scoped lang="scss">
.item-group-page {
  &__item {
    white-space: nowrap;
  }
}

::v-deep .v-data-table thead th {
  white-space: nowrap;
}
</style>
